// src/app/shared/services/toast.service.ts
import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { ToastComponent } from '../shared-components/toast/toast.component';

export enum ToastType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
  Remove = 'remove',
}

export enum ToastDuration {
  LENGTH_LONG = 3500,
  LENGTH_SHORT = 2000,
}

export type ToastOptions = {
  duration?: ToastDuration;
  horizontalPosition?: MatSnackBarHorizontalPosition;
  verticalPosition?: MatSnackBarVerticalPosition;
  panelClass?: string;
};

@Injectable({ providedIn: 'root' })
export class ToastService {
  defaultOptions: ToastOptions = {
    duration: ToastDuration.LENGTH_LONG,
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
    panelClass: 'custom-toast',
  };
  constructor(private snackBar: MatSnackBar) {}

  show(
    message: string,
    type: ToastType = ToastType.Info,
    options: ToastOptions = this.defaultOptions
  ) {
    const snackBarRef = this.snackBar.openFromComponent(ToastComponent, {
      data: { message, type },
      duration: options.duration,
      verticalPosition: options.verticalPosition,
      panelClass: options.panelClass,
    });
    if (parseInt(navigator.userAgent.match(/Chrome\/(\d+)/)?.[1] || '0') < 40) {
      setTimeout(() => {
        // Remove all snackbar containers from DOM
        const snackBarContainers = document.querySelectorAll(
          'snack-bar-container'
        );
        snackBarContainers.forEach((container) => {
          container.remove();
        });
      }, options.duration);
    }
  }

  success(message: string, options?: ToastOptions) {
    this.show(message, ToastType.Success, {
      ...this.defaultOptions,
      ...options,
    });
  }

  error(message: string, options?: ToastOptions) {
    this.show(message, ToastType.Error, { ...this.defaultOptions, ...options });
  }

  info(message: string, options?: ToastOptions) {
    this.show(message, ToastType.Info, { ...this.defaultOptions, ...options });
  }

  warning(message: string, options?: ToastOptions) {
    this.show(message, ToastType.Warning, {
      ...this.defaultOptions,
      ...options,
    });
  }

  remove(message: string, options?: ToastOptions) {
    this.show(message, ToastType.Remove, {
      ...this.defaultOptions,
      ...options,
    });
  }
}
